<div mat-dialog-title class="popup_border_icd">
  <h5 class="header_txt">{{header_text}}</h5>
  <div mat-dialog-actions>
    <img src="../../../assets/img/close_icon.png" (click)="ClosePopup()" width="20px" height="20px" id="close_icd" />
  </div>
</div>
<div mat-dialog-content class="icd_content">
  <div class="container">
    <div class="row">
      <div class="chart_div graph_size">
      <div id={{graph_id}}></div>
    </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" style="width: auto;right: 19px;">
</div>